// import React from 'react';
// import './style.less';

// export default ({
//   type,
//   className,
//   style,
//   size = 'md'
// }) => {
//   return (<svg className={['rpticon', className, 'icon'+type, 'iconfont', size].filter(it=>it).join(' ')} aria-hidden="true" style={style}>
//             <use xlinkHref={"#icon-"+type}></use>
//         </svg>);
// }


import * as React from 'react';
import './style.less';

export default ({
  type,
  className,
  style,
  size = 'md',
  onClick=() => {}
}) => {
  // return <i 
  //         title={title} 
  //         className={((type || icon)?'iconfont icon-'+(type || icon):'')+ (className?' '+className:'')} 
  //         {...others} 
  //         />
  return (

    <svg className={['rpticon', className, 'icon-'+type, 'iconfont', size].filter(it=>it).join(' ')} aria-hidden="true" style={style} onClick={onClick}>
      <use xlinkHref={"#icon-" + type}></use>
    </svg >
  )
}
